import React, { useState, useEffect } from "react";
import { FileText, AlertCircle, ArrowLeft } from "lucide-react";
import { Footer } from "./Footer";
import { Header } from "./Header";
import { useNavigate } from "react-router-dom";
import { getWithoutTokenAPI } from "../util/Api";

const ShippingExchange = () => {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getWithoutTokenAPI("/shipping-exchange-policy/get_all");
        if (response?.statusCode === 200 && response.data) {
          const resData = Array.isArray(response.data) ? response.data[0] : response.data;
          if (resData && !resData.is_deleted) {
            setData(resData);
          }
        }
      } catch (error) {
        console.error("Error fetching shipping policy:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      <Header />

      {/* Back link */}
      <div className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center h-16">
            <button
              onClick={() => navigate("/")}
              className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors cursor-pointer"
            >
              <ArrowLeft className="w-5 h-5" />
              <span className="text-base font-medium">Back</span>
            </button>
          </div>
        </div>
      </div>

      {/* Page Content */}
      <div style={{minHeight: "100vh", paddingTop: "2rem"}}>
        <div
          style={{
            width: "90%",
            maxWidth: "900px",
            margin: "0 auto 4rem auto",
            backgroundColor: "white",
            padding: "3rem",
            borderRadius: "16px",
            boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
          }}
        >
          {/* Header */}
          <div
            style={{
              textAlign: "center",
              marginBottom: "2.5rem",
              paddingBottom: "2rem",
              borderBottom: "2px solid #fee2e2",
            }}
          >
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "12px",
                marginBottom: "1rem",
              }}
            >
              <div
                style={{
                  padding: "12px",
                  borderRadius: "12px",
                  background: "linear-gradient(to right bottom, rgb(220, 38, 38), rgb(243, 67, 67))",
                  color: "white",
                  flexShrink: 0,
                }}
              >
                <FileText size={28} />
              </div>
              <h1
                style={{
                  fontSize: "2.5rem",
                  fontWeight: "700",
                  background: "linear-gradient(to right bottom, rgb(220, 38, 38), rgb(243, 67, 67))",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                  margin: 0,
                  lineHeight: 1.2,
                }}
              >
                {data?.title || "Shipping & Exchange Policy"}
              </h1>
            </div>
            <p style={{ fontSize: "0.95rem", color: "#888" }}>
              Last Updated:{" "}
              {new Date().toLocaleDateString("en-IN", {
                day: "numeric",
                month: "long",
                year: "numeric",
              })}
            </p>
          </div>

          {/* Dynamic Content from API */}
          {loading ? (
            <div style={{ textAlign: "center", padding: "2rem", color: "#9ca3af" }}>Loading...</div>
          ) : data?.content ? (
            <div
              style={{
                fontSize: "1rem",
                lineHeight: "1.8",
                color: "#374151",
              }}
            >
              {data.content.includes("<") ? (
                <div dangerouslySetInnerHTML={{ __html: data.content }} />
              ) : (
                <p style={{ whiteSpace: "pre-wrap" }}>{data.content}</p>
              )}
            </div>
          ) : (
            /* Fallback static content */
            <div style={{ textAlign: "center", color: "#6b7280", padding: "2rem" }}>
              <p>Shipping & Exchange policy is not available at the moment.</p>
            </div>
          )}
        </div>

        <Footer />
      </div>
    </>
  );
};

export default ShippingExchange;
